import React from "react";
import Link from "next/link";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import CircleIcon from "@mui/icons-material/Circle";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import { monthConvertDMY } from "@/features/monthConvert";

function NewsListMain({ data }: any) {
  let DATA;
  let TOTAL;
  if (data) {
    DATA = data;
    TOTAL = data.length;
  } else {
    DATA = [];
    TOTAL = 1;
  }

  const [page, setPage] = React.useState<any>(0);
  const rowsPerPage = 10;
  const TOTAL_PAGE = Math.ceil(TOTAL / rowsPerPage);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value - 1);
  };

  return (
    <div className="news-list">
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        alignItems="center"
      >
        {DATA.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(
          (row: any, index: any) => {
            return (
              <Grid xs={12} sm={12} md={12} key={index} alignItems="center">
                <Link href={`/en/NewsDetail/${row.news_id}`}>
                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={{ xs: 1, sm: 2, md: 4 }}
                    justifyContent="flex-start"
                    alignItems="center"
                    className="news-list_inner"
                  >
                    <div className="news-date col-12 col-lg-2">
                      <CircleIcon
                        sx={{
                          fontSize: "12px",
                          mr: 2,
                          mb: 0.5,
                          color: "#0179CC",
                        }}
                      />
                      {monthConvertDMY(row.post_date)}
                    </div>
                    <Divider orientation="vertical" flexItem></Divider>

                    <div className="news-subject col-12 col-lg-9">
                      {row.topic}
                    </div>
                  </Stack>
                </Link>
              </Grid>
            );
          }
        )}
      </Grid>
      <div className="d-flex justify-content-center text-center mt-3">
        <Stack
          sx={{ my: 5 }}
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Pagination
            count={TOTAL_PAGE}
            onChange={handleChange}
            showFirstButton
            showLastButton
            color="primary"
          />
        </Stack>
      </div>
    </div>
  );
}

export default NewsListMain;
